// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

/* Global: prevent background scroll/click when any custom modal is open */
body.agce-modal-open {
  position: fixed !important;
  left: 0 !important;
  right: 0 !important;
  /* Keep normal document width; scrollbar gutter already stabilized on html */
  width: 100% !important;
  overflow: hidden !important;
  touch-action: none !important;
  overscroll-behavior: none !important;
}

/* When body is fixed for modal lock, freeze sticky header too */
body.agce-modal-open header.sticky-top {
  /* Do not force vw widths (causes horizontal jump on macOS); keep header stable */
  width: 100% !important;
  /* Keep header behind modals/backdrop + disable hover/click bubbling */
  z-index: 1040 !important;
  pointer-events: none !important;
}

/* Bootstrap adds padding-right on modal-open; we handle stability ourselves */
body.modal-open {
  padding-right: 0 !important;
}

html.agce-modal-open {
  overflow: hidden !important;
  height: 100% !important;
  overscroll-behavior: none !important;
  touch-action: none !important;
}

/* Mobile Safari / nested scroll: lock the React root while overlays are open */
body.agce-modal-open #root {
  overflow: hidden !important;
  touch-action: none !important;
}

/* Keep layout stable when scrollbars appear/disappear */
html {
  scrollbar-gutter: stable both-edges;
  overflow-y: scroll;
}

/* Fix: \`style.css\` makes \`.modal.fade .modal-dialog\` fixed bottom-sheet.
   Keep that behavior only for small screens; on desktop restore normal modal positioning. */
@media (min-width: 576px) {

  /* .modal.fade .modal-dialog {
    position: relative !important;
    bottom: auto !important;
    left: auto !important;
    right: auto !important;
    width: auto !important;
    max-width: var(--bs-modal-width, 500px) !important;
    margin: 1.75rem auto !important;
    transform: none !important;
    transition: none !important;
    align-items: stretch !important;
  } */
  .modal.fade.show .modal-dialog {
    transform: none !important;
  }
}

/* Fix browser autofill background for dark theme */
input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
input:-webkit-autofill:active {
  -webkit-box-shadow: 0 0 0 1000px #1a1a1a inset !important;
  -webkit-text-fill-color: #e0e0e0 !important;
  -webkit-transition: background-color 5000s ease-in-out 0s;
  transition: background-color 5000s ease-in-out 0s;
}

/* Fix browser autofill background for light theme */
body.light_theme input:-webkit-autofill,
body.light_theme input:-webkit-autofill:hover,
body.light_theme input:-webkit-autofill:focus,
body.light_theme input:-webkit-autofill:active {
  -webkit-box-shadow: 0 0 0 1000px #f5f6f7 inset !important;
  -webkit-text-fill-color: #1a1d21 !important;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA,0EAA0E;AAC1E;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,mBAAmB;EACnB,4EAA4E;EAC5E,sBAAsB;EACtB,2BAA2B;EAC3B,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA,gEAAgE;AAChE;EACE,iFAAiF;EACjF,sBAAsB;EACtB,sEAAsE;EACtE,wBAAwB;EACxB,+BAA+B;AACjC;;AAEA,8EAA8E;AAC9E;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;EAC3B,uBAAuB;EACvB,oCAAoC;EACpC,6BAA6B;AAC/B;;AAEA,+EAA+E;AAC/E;EACE,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA,wDAAwD;AACxD;EACE,mCAAmC;EACnC,kBAAkB;AACpB;;AAEA;4FAC4F;AAC5F;;EAEE;;;;;;;;;;;KAWG;EACH;IACE,0BAA0B;EAC5B;AACF;;AAEA,mDAAmD;AACnD;;;;EAIE,yDAAyD;EACzD,2CAA2C;EAC3C,yDAAiD;EAAjD,iDAAiD;AACnD;;AAEA,oDAAoD;AACpD;;;;EAIE,yDAAyD;EACzD,2CAA2C;AAC7C","sourcesContent":[".App {\n  text-align: center;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* Global: prevent background scroll/click when any custom modal is open */\nbody.agce-modal-open {\n  position: fixed !important;\n  left: 0 !important;\n  right: 0 !important;\n  /* Keep normal document width; scrollbar gutter already stabilized on html */\n  width: 100% !important;\n  overflow: hidden !important;\n  touch-action: none !important;\n  overscroll-behavior: none !important;\n}\n\n/* When body is fixed for modal lock, freeze sticky header too */\nbody.agce-modal-open header.sticky-top {\n  /* Do not force vw widths (causes horizontal jump on macOS); keep header stable */\n  width: 100% !important;\n  /* Keep header behind modals/backdrop + disable hover/click bubbling */\n  z-index: 1040 !important;\n  pointer-events: none !important;\n}\n\n/* Bootstrap adds padding-right on modal-open; we handle stability ourselves */\nbody.modal-open {\n  padding-right: 0 !important;\n}\n\nhtml.agce-modal-open {\n  overflow: hidden !important;\n  height: 100% !important;\n  overscroll-behavior: none !important;\n  touch-action: none !important;\n}\n\n/* Mobile Safari / nested scroll: lock the React root while overlays are open */\nbody.agce-modal-open #root {\n  overflow: hidden !important;\n  touch-action: none !important;\n}\n\n/* Keep layout stable when scrollbars appear/disappear */\nhtml {\n  scrollbar-gutter: stable both-edges;\n  overflow-y: scroll;\n}\n\n/* Fix: `style.css` makes `.modal.fade .modal-dialog` fixed bottom-sheet.\n   Keep that behavior only for small screens; on desktop restore normal modal positioning. */\n@media (min-width: 576px) {\n\n  /* .modal.fade .modal-dialog {\n    position: relative !important;\n    bottom: auto !important;\n    left: auto !important;\n    right: auto !important;\n    width: auto !important;\n    max-width: var(--bs-modal-width, 500px) !important;\n    margin: 1.75rem auto !important;\n    transform: none !important;\n    transition: none !important;\n    align-items: stretch !important;\n  } */\n  .modal.fade.show .modal-dialog {\n    transform: none !important;\n  }\n}\n\n/* Fix browser autofill background for dark theme */\ninput:-webkit-autofill,\ninput:-webkit-autofill:hover,\ninput:-webkit-autofill:focus,\ninput:-webkit-autofill:active {\n  -webkit-box-shadow: 0 0 0 1000px #1a1a1a inset !important;\n  -webkit-text-fill-color: #e0e0e0 !important;\n  transition: background-color 5000s ease-in-out 0s;\n}\n\n/* Fix browser autofill background for light theme */\nbody.light_theme input:-webkit-autofill,\nbody.light_theme input:-webkit-autofill:hover,\nbody.light_theme input:-webkit-autofill:focus,\nbody.light_theme input:-webkit-autofill:active {\n  -webkit-box-shadow: 0 0 0 1000px #f5f6f7 inset !important;\n  -webkit-text-fill-color: #1a1d21 !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
